import type { Components } from '@mui/material'

export const OmuiStatusBar: NonNullable<Components['OmuiStatusBar']> = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.spacing(7),
      color: 'white',
    }),

    divider: ({ theme }) => ({
      borderColor: 'white',
      borderRightWidth: 1,
      opacity: 0.2,
      height: theme.spacing(3.5),
      alignSelf: 'center',
    }),
    message: {
      color: 'white',
    },
    icon: {
      color: 'white',

      '& .MuiCircularProgress-root': {
        color: 'inherit',
      },
    },
    closeButton: ({ theme, ownerState }) => ({
      color: 'white',
      '& .MuiCircularProgress-root': {
        opacity: 0.6,
      },
      marginRight: theme.spacing(2),
      marginLeft: ownerState?.hasAction ? theme.spacing(2) : theme.spacing(4),
    }),
  },
  variants: [
    {
      props: { variant: 'loading' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.primary.main,
      }),
    },
    {
      props: { variant: 'success' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.green[700],
      }),
    },
    {
      props: { variant: 'error' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.error.main,
      }),
    },
    {
      props: { variant: 'warning' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.warning.main,
      }),
    },
  ],
}
